import { Component } from '@theme/component';

/**
 * Sticky anchor nav for the product info sections (Overview, Features,
 * Specifications, Installation, Downloads, FAQs). Pure anchor links so it
 * works with no JS; this only adds scroll-spy active-state highlighting and
 * a small offset so the sticky bar doesn't cover the section heading.
 */
class TabNavComponent extends Component {
  // The links carry ref="link[]"; the base class stores a list ref under its name without the brackets.
  requiredRefs = ['link'];

  connectedCallback() {
    super.connectedCallback();

    /** @type {Map<string, HTMLAnchorElement>} */
    this.linksById = new Map();

    for (const link of this.refs.link) {
      const id = link.getAttribute('href')?.slice(1);
      if (id) this.linksById.set(id, link);
    }

    this.observer = new IntersectionObserver((entries) => this.#handleIntersect(entries), {
      rootMargin: '-40% 0px -55% 0px',
      threshold: 0,
    });

    for (const id of this.linksById.keys()) {
      const section = document.getElementById(id);
      if (section) this.observer.observe(section);
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  /** @param {IntersectionObserverEntry[]} entries */
  #handleIntersect(entries) {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const link = this.linksById.get(entry.target.id);
      if (!link) continue;

      for (const other of this.refs.link) {
        other.classList.toggle('is-active', other === link);
      }
    }
  }
}

if (!customElements.get('tab-nav-component')) {
  customElements.define('tab-nav-component', TabNavComponent);
}
